import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// Suppress benign ResizeObserver browser warnings that CRA dev overlay treats as runtime errors.
const isResizeObserverNoise = (value) => {
  const text = String(value || '');
  return text.includes('ResizeObserver loop limit exceeded')
    || text.includes('ResizeObserver loop completed with undelivered notifications');
};

const previousOnError = window.onerror;
window.onerror = (message, ...args) => {
  if (isResizeObserverNoise(message)) return true;
  return previousOnError?.call(window, message, ...args) ?? false;
};

window.addEventListener(
  'error',
  (event) => {
    const message = event?.message || event?.error?.message;
    if (!isResizeObserverNoise(message)) return;

    event.preventDefault();
    event.stopImmediatePropagation();
  },
  true
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
